import { Injectable } from '@angular/core';
import { ENVIRONMENT } from '../../../../environment/environment';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ApiResponse } from '../../models/api-response.model';

@Injectable({
    providedIn: 'root',
})
export class DocumentService {
    apiRoute = `${ENVIRONMENT.apiDomain}/api/v1/document`;

    constructor(private httpClient: HttpClient) {}

    public getTermsAndCondition(): Observable<ApiResponse<string>> {
        return this.httpClient.get<ApiResponse<string>>(`${this.apiRoute}/terms-and-condition`);
    }

    public getPrivacyPolicy(): Observable<ApiResponse<string>> {
        return this.httpClient.get<ApiResponse<string>>(`${this.apiRoute}/privacy-policy`);
    }
    public getRefundPolicy():
    Observable<ApiResponse<string>> {
        return this.httpClient.get<ApiResponse<string>>(
            `${this.apiRoute}/refund-policy`
        );
    }
}
